import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { selectApp, goToPage, showLeaderboards } from '../../HOME/REDUX/actions';
import { setScore } from '../REDUX/actions';
import { START_PAGE, GAME_PAGE, HIDE, SKILL_PAGE } from '../../HOME/const';
import BackIcon from '../../HOME/SVG/BackIcon';
import { hideLeaderboards } from '../../HOME/utils';
import { PRACTICE } from '../const';
import useGoHome from '../../HOME/useGoHome';

function BackButton(props) {
  const goHome = useGoHome();

  if (props.singleApp && props.page === START_PAGE) {
    return null;
  }

  return (
    <div
      className="navigation-button"
      onClick={() => {
        switch (props.page) {
          case START_PAGE:
            goHome();
            return;
          case SKILL_PAGE:
            props.goToPage(START_PAGE);
            return;
          case GAME_PAGE:
            if (props.mode === PRACTICE) {
              props.goToPage(START_PAGE);
            } else if (props.showLeaders === HIDE) {
              let { hits, misses } = props;
              if (misses > 2) {
                hits = 0;
                misses = 0;
                props.setScore(0, 0, 0);
              }
              if (hits === 0 && misses === 0 && props.levelsCompleted > 0) {
                props.goToPage(SKILL_PAGE);
              } else {
                props.goToPage(START_PAGE);
              }
            } else {
              hideLeaderboards(props.showLeaderboards);
            }
            return;
          default:
            return;
        }
      }}>
      <BackIcon width="36" className="navigation-button" />
    </div>
  );
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, selectApp, showLeaderboards, setScore }
)(BackButton);
